import { render } from "./ProjectPurposeCard.vue?vue&type=template&id=1d899228"
import script from "./ProjectPurposeCard.vue?vue&type=script&lang=js"
export * from "./ProjectPurposeCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__